<template>
  <div>
    <div class="login-wrapper" :style="loginWrapperStyle">
      <div class="login">
        <!-- <img class="bgcImg" src="@/assets/images/login/login.png" alt=""> -->
        <div class="project" v-show="!isEn">
          <img class="password" src="@/assets/images/login/logo1.png" alt="">
          <!-- <zws-image width="42px" height="42px" :src="data.projectLogo"></zws-image> -->
          <!-- <zws-text :text="data.projectName" :color="data.loginTextColor" fontSize="20px" marginLeft="10px"></zws-text> -->
        </div>
        <div class="project" v-show="isEn">
          <img class="logo" src="@/assets/images/login/logo_white.png">
          <h1 class="projectname">Zhiyuan Label Printing System</h1>
        </div>
        <div class="content">
          <div class="main">
            <div class="user-name">
              <el-input class="inputUsername" size="medium" auto-complete="new-password" :placeholder="data.usernamePlaceholder" v-model.trim="inputUsername">
                <!-- <i slot="prefix" :style="prefixIconColor" class="el-input__icon el-icon-user"></i> -->
              </el-input>
              <img class="username" src="@/assets/images/login/username.png" alt="">
            </div>
            <div class="user-password">
              <el-input class="inputPassword" size="medium" auto-complete="new-password" :placeholder="data.passwordPlaceholder" v-model="inputPassword" @keyup.enter.native="loginButtonClick" :type="showPasswordFlag?'text':'password'">
                <!-- <i slot="prefix" :style="prefixIconColor" class="el-input__icon el-icon-unlock"></i> -->
                <!-- <i slot="suffix" :style="suffixIconColor" :class="showPasswordFlag?'el-input__icon el-icon-view':'el-input__icon el-icon-view' " @click="showPasswordClick"></i> -->
              </el-input>
              <img class="password" src="@/assets/images/login/password.png" alt="">
              <img @click="showPasswordClick" v-show="!showPasswordFlag" class="eyes-image" src="@/assets/images/login/show.png" alt="">
              <img @click="showPasswordClick" v-show="showPasswordFlag" class="eyes-image" src="@/assets/images/login/hidden.png" alt="">
            </div>
            <!-- <zws-input :inputValue="inputUsername" :placeholder="data.usernamePlaceholder" v-on:inputValue="getInputUsername" :prefixIconSrc="data.usernamePrefixIconSrc"></zws-input>
            <zws-input :inputValue="inputPassword" :placeholder="data.passwordPlaceholder" v-on:inputValue="getInputPassword" marginTop="10px" :type="showPasswordFlag?'text':'password'" :prefixIconSrc="data.passwordPrefixIconSrc" :suffixIconSrc="showPasswordFlag?data.passwordSuffixIconSrcVisible:data.passwordSuffixIconSrcInVisible" @suffixIconClick="showPasswordClick"></zws-input> -->
            <div class="remember-wrapper">
              <div class="checkbox-wrapper">
                <el-checkbox class="checkbox" v-model="inputRememberFlag"></el-checkbox>
                <span class="checkbox-text" @click="inputRememberFlag = !inputRememberFlag">{{data.rememberPassword}}</span>
              </div>
              <!-- <zws-text :text="data.forgetPassword" :color="data.loginTextColor" fontSize="14px" cursor="pointer" @click="forgetTextClick"></zws-text> -->
            </div>
            <div class="button-wrapper">
              <el-button class="button-login" :style="buttonLoginStyle" type="primary" @click="loginButtonClick">{{data.loginButtonText}}</el-button>
              <el-button v-if="data.showExperienceButton" class="button-experience" type="primary" @click="experienceTextClick">{{data.experienceAccount}}</el-button>
            </div>
            <!-- <zws-text :text="data.toRegister" :color="data.loginTextColor" fontSize="14px" cursor="pointer" textAlign="end" marginTop="10px" @click="registerTextClick"></zws-text> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import zwsText from '../../../Common/ZWSComponent/Text.vue'
import zwsImage from '../../../Common/ZWSComponent/Image.vue'
import zwsInput from '../../../Common/ZWSComponent/Input.vue'
import { setTimeout } from 'timers'
export default {
  components: { zwsText, zwsImage, zwsInput },
  props: {
    propsList: {
      type: Object
    }
  },
  data () {
    return {
      inputUsername: '',
      inputPassword: '',
      inputRememberFlag: false,
      showPasswordFlag: false,
      // iconColor: '#d8383a',
      data: {
        username: '',
        password: '',
        rememberFlag: false,
        showExperienceButton: true,
        projectLogo: require('../../../Resource/Image/logo.png'),
        projectName: '项目名',
        projectThemeColor: '',
        usernamePlaceholder: '请输入用户名',
        passwordPlaceholder: '请输入密码',
        // usernamePrefixIconSrc: require('../../../Resource/Image/login_username_icon.png'),
        // passwordPrefixIconSrc: require('../../../Resource/Image/login_password_icon.png'),
        // passwordSuffixIconSrcVisible: require('../../../Resource/Image/icon-visible.png'),
        // passwordSuffixIconSrcInVisible: require('../../../Resource/Image/icon-invisible.png'),
        rememberPassword: '记住密码',
        forgetPassword: '忘记密码?',
        loginButtonText: '登录',
        experienceAccount: '体验账号',
        toRegister: '没有账号?马上注册',
        loginWidth: '400px',
        loginHeight: '',
        loginBackgroundColor: '#25374f',
        loginTextColor: '#292a30'
      },
      iconColor: '#1ba7c8',
      isEn: false
      // prefixIconColor: {
      //   color: '#1ba7c8'
      // }
    }
  },
  computed: {
    prefixIconColor () {
      return {
        color: this.data.projectThemeColor
        // color: this.iconColor
      }
    },
    suffixIconColor () {
      return {
        color: this.showPasswordFlag ? this.data.projectThemeColor : ''
      }
    },
    loginWrapperStyle () {
      return {
        width: this.data.loginWidth ? this.data.loginWidth : '340px',
        height: this.data.loginHeight ? this.data.loginHeight : '350px',
        backgroundColor: this.data.loginBackgroundColor
      }
    },
    buttonLoginStyle () {
      return {
        // backgroundColor: this.data.loginTextColor,
        // borderColor: this.data.loginTextColor
      }
    }
  },
  created () {
    if (this.propsList && Object.keys(this.propsList).length !== 0) {
      for (const key in this.data) {
        for (const k in this.propsList) {
          if (k === key) {
            this.data[key] = this.propsList[k]
          }
        }
      }
    }
    this.isEn = localStorage.getItem('zlb_label_language') && localStorage.getItem('zlb_label_language') === 'en'
    this.data.loginButtonText = this.isEn ? 'Login' : '登录'
    this.data.rememberPassword = this.isEn ? 'Remember password' : '记住密码'
    this.data.usernamePlaceholder = this.isEn ? 'Please enter username' : '请输入用户名'
    this.data.passwordPlaceholder = this.isEn ? 'Please enter password' : '请输入密码'
    this.inputRememberFlag = localStorage.getItem('label_remember_password') === 'true'
    this.$i18n.locale = localStorage.getItem('zlb_label_language') || 'zh'
    if (this.inputRememberFlag) {
      this.data.username = JSON.parse(localStorage.getItem('remember_label_userinfo')).usename
      this.data.password = JSON.parse(localStorage.getItem('remember_label_userinfo')).password
    }
    this.inputUsername = this.data.username
    this.inputPassword = this.data.password
    // this.bus.$on('selectedColor', res => {
    //   this.iconColor = res
    //   console.log('selectedColor1--prefixIconColor-', this.iconColor)
    //   setTimeout(() => {
    //     console.log('selectedColor2--prefixIconColor-', this.iconColor)
    //   }, 2000)
    // })
  },
  methods: {
    rememberPassWord () {
      localStorage.setItem('label_remember_password', this.inputRememberFlag)
      if (this.inputRememberFlag) {
        let userinfo = {
          usename: this.inputUsername,
          password: this.inputPassword
        }
        localStorage.setItem('remember_label_userinfo', JSON.stringify(userinfo))
      }
    },
    getInputUsername (value) {
      this.inputUsername = value
    },
    getInputPassword (value) {
      this.inputPassword = value
    },
    showPasswordClick () {
      this.showPasswordFlag = !this.showPasswordFlag
    },
    forgetTextClick () {
      this.$emit('forgetTextClick')
    },
    loginButtonClick () {
      if (this.inputRememberFlag) {
        this.rememberPassWord()
      } else {
        localStorage.removeItem('remember_label_userinfo')
        localStorage.removeItem('label_remember_password')
      }
      this.$emit('loginButtonClick', {
        username: this.inputUsername ? this.inputUsername : '',
        password: this.inputPassword ? this.inputPassword : '',
        rememberFlag: this.inputRememberFlag
      })
    },
    experienceTextClick () {
      this.$emit('experienceTextClick')
    },
    registerTextClick () {
      this.$emit('registerTextClick')
    },
    IE9Compat (ele) {
      let isIE9 = 'placeholder' in document.createElement('input');
      if (!isIE9) { // 判断浏览器是否支持 placeholder
        let that = this
        $(ele).focus(function() {
          var input = $(this)
          if (input.val() == input.attr('placeholder')) {
            input.val('')
            input.removeClass('placeholder')
          }
        }).blur(function() {
          var input = $(this)
          if (input.val() == '' || input.val() == input.attr('placeholder')) {
            input.addClass('placeholder')
            input.val(input.attr('placeholder'))
          }
        }).blur()
      }
    }
  },
  mounted () {
    this.IE9Compat('.inputUsername input')
    this.IE9Compat('.inputPassword input')
  }
}
</script>

<style lang="less">
.login-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  .login {
    width: 530px;
    height: 347px;
    padding-left: 184px;
    background-image: url('../../../../../src/assets/images/login/loginBGC1.png');
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    .bgcImg {
      width: 184px;
      height: 338px;
      position: absolute;
      top: 0;
      left: 0;
    }
    .project {
      height: 108px;
      line-height: 108px;
      font-size: 16px;
      padding-left: 38px;
      position: relative;
      box-sizing: border-box;
      -ms-box-sizing: border-box;
      > img {
        position: absolute;
        top: 36px;
        left: 65px;
      }
      .logo {
        top: 45px;
        left: 30px;
      }
      .projectname {
        width: 100%;
        margin-left: 10px;
        font-size: 16px;
        color: #fff;
        // font-weight: bold;
      }
    }
    .content {
      .main {
        .user-name {
          position: relative;
          .username {
            position: absolute;
            top: 8px;
            left: 50px;
          }
        }
        .user-password {
          position: relative;
          .password {
            position: absolute;
            top: 22px;
            left: 50px;
          }
          .eyes-image {
            cursor: pointer;
            position: absolute;
            top: 22px;
            right: 50px;
          }
        }
        .el-input__icon {
          font-size: 20px;
        }
        .el-input-icon-color {
          color: #11a983;
        }
        .inputUsername {
          width: 260px;
        }
        .inputPassword {
          width: 260px;
          margin-top: 14px;
        }
        .remember-wrapper {
          padding: 0 40px;
          margin-top: 16px;
          .checkbox-wrapper {
            position: relative;
            height: 20px;
            line-height: 20px;
            .checkbox {
              position: absolute;
              left: 0;
            }
            .checkbox-text {
              cursor: pointer;
              color: #ffffff;
              font-size: 14px;
              position: absolute;
              left: 24px;
            }
          }

          .forget-text {
            font-size: 14px;
            color: #fff;
          }
        }
        .button-wrapper {
          padding: 0 41px 0px 37px;
          margin-top: 30px;
          .button-login {
            width: 100%;
            color: #ffffff;
          }
          .button-experience {
            background-color: #103a5e;
          }
        }
        .register-text {
          font-size: 14px;
          text-align: end;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// third_party/common_app/LoginModule/View/Ctrl/LoginCtrl.vue